import { render, staticRenderFns } from "./OTT.vue?vue&type=template&id=0ce0d1d9"
import script from "./OTT.vue?vue&type=script&lang=js"
export * from "./OTT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports